import { defineComponent as _defineComponent } from 'vue'
import { useAppStore } from "@/ts/stores/app";
import { Slideout } from "@/ts/components/elements";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

interface Props {
    centerLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    rightLinks?: Array<{ class: string; target: string; title: string; url: string }>;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    centerLinks: { type: Array, required: false },
    rightLinks: { type: Array, required: false }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    centerLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    rightLinks?: Array<{ class: string; target: string; title: string; url: string }>;
}

const breakpoints = useBreakpoints(breakpointsTailwind);
const showNavigation = breakpoints.smaller("lg");

const appStore = useAppStore();



const __returned__ = { breakpoints, showNavigation, appStore, props, Slideout }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})